// extracted by mini-css-extract-plugin
module.exports =  {"button":"mI_jFCqneEwoh0KSVK4j"};